import { formatPrice } from "../../../../../../common/helpers/formatPrice";
import { extractCurrencyInfo } from "../../../../../../common/helpers/currency";
import type { RawCartCoupon } from "../../../../../../types";
import type { TransformedCartCoupon } from "../../../types/cartApiTypes";

/**
 * A pure helper function to transform an array of raw coupon objects.
 * @param rawCoupons The raw coupons array from the WC Store API.
 * @returns An array of transformed coupon objects.
 */
export const transformCoupons = (
  rawCoupons: RawCartCoupon[]
): TransformedCartCoupon[] => {
  if (!Array.isArray(rawCoupons)) {
    return [];
  }

  return rawCoupons.map((coupon) => {
    // Extract currency info from the coupon's totals object
    const currencyInfo = extractCurrencyInfo(coupon.totals);

    // The API provides total_discount (pre-tax) and total_discount_tax.
    // We prioritize showing the pre-tax discount amount.
    const discountAmountToShow =
      coupon.totals.total_discount || coupon.totals.total_discount_tax || "0";

    return {
      code: coupon.code,
      discountType: coupon.discount_type,
      totals: {
        totalDiscount: formatPrice(coupon.totals.total_discount, currencyInfo),
        totalDiscountTax: formatPrice(
          coupon.totals.total_discount_tax,
          currencyInfo
        ),
        // This new property simplifies display logic in the component
        displayDiscount: formatPrice(discountAmountToShow, currencyInfo),
      },
    };
  });
};
